let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("id622")).then(() => parcelRequire('knvxB'));